import { render, staticRenderFns } from "./ReferentialScore.vue?vue&type=template&id=13b3ec53&scoped=true"
import script from "./ReferentialScore.vue?vue&type=script&lang=js"
export * from "./ReferentialScore.vue?vue&type=script&lang=js"
import style0 from "./ReferentialScore.vue?vue&type=style&index=0&id=13b3ec53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b3ec53",
  null
  
)

export default component.exports